import { render, staticRenderFns } from "./operation_records.vue?vue&type=template&id=5a3a2540&scoped=true&"
import script from "./operation_records.vue?vue&type=script&lang=js&"
export * from "./operation_records.vue?vue&type=script&lang=js&"
import style0 from "./operation_records.vue?vue&type=style&index=0&id=5a3a2540&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a3a2540",
  null
  
)

export default component.exports